import React, { Component, createRef } from "react";
import Link from "../../../Link.js";
class Theme13 extends Component {
  constructor() {
    super();
    this.state = {
      scrolling: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  };

  handleScroll = (event) => {;
    if (window.scrollY <= 30 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY > 30 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  };
   // 🔹 NEW FUNCTION — handles redirect on logo click
   handleLogoClick = () => {
    const redirectUrl = this.props?.redirectUrl || "/"; // 🔹 CHANGED
    try {
      // 🔹 Use top window navigation (handles iframe case)
      if (window.top) {
        window.top.location.href = redirectUrl;
      } else {
        window.location.assign(redirectUrl);
      }
    } catch (error) {
      console.error("Logo redirect failed:", error);
    }
  };

  render() {
   
    return (
      <>
      <div className={this.props?.styles?.mobile_header_logoContainer}>
        <div className={`${this.props?.styles?.mobile_header_logoWrap} ${this.props.showAlertBar && this.state.scrolling ? this.props?.styles?.header_sticky_mobile : ''}`}>
        <div
          title="Logo"
          // href={this.props?.redirectUrl || '/'}
          className=""
          // onClick={e => {
          // e.preventDefault();
          // window.open(this.props?.redirectUrl || '/', '_blank');
          // }}
          onClick={this.handleLogoClick} 
        >
          <img
          className={this.props?.styles?.header_logo}
          src={
            "/shared/api/media/" +
            (this.props?.logo)
          }
          alt="logodata"
          />
        </div>
        </div>
      </div>
      </>
    );
  }
}

export default Theme13;
